import { render, staticRenderFns } from "./MarkSheetContent.vue?vue&type=template&id=bf9d56ba&scoped=true"
import script from "./MarkSheetContent.vue?vue&type=script&lang=js"
export * from "./MarkSheetContent.vue?vue&type=script&lang=js"
import style0 from "./MarkSheetContent.vue?vue&type=style&index=0&id=bf9d56ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9d56ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCardText,VChip,VDataTable,VForm,VIcon,VTextarea})
